import {
	addPlayer,
	clearPicksHistory,
	fetchFriendPicks,
	fetchFriendPicksByPlayer,
	fetchFriendPicksByPlayerPutSuccess,
	fetchFriendPicksByPlayerSuccess,
	fetchFriendPicksSuccess,
	fetchPredictions,
	getHistoryAPISuccess,
	getPredictionsAPISuccess,
	getPredictionsPutStoreSuccess,
	removePick,
	toggleMulliganModal,
	setInsightsViewState,
	hideMulliganModal,
} from "modules/actions/streak";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";

interface IStreakStore {
	predictions: ReturnType<typeof getPredictionsAPISuccess>["payload"]["predictions"];
	resentHistory: ReturnType<typeof getPredictionsAPISuccess>["payload"]["resentHistory"];
	history: ReturnType<typeof getHistoryAPISuccess>["payload"];
	friendHistory: ReturnType<typeof fetchFriendPicksSuccess>["payload"];
	requestStatePicks: RequestState;
	requestStateHistory: RequestState;
	requestStateFriends: RequestState;
	friendPicksByPlayerId: Record<
		string,
		ReturnType<typeof fetchFriendPicksByPlayerSuccess>["payload"] &
			ReturnType<typeof fetchFriendPicksByPlayer>["payload"]
	>;
	modals: {
		mulliganModalState: boolean;
		isOpenInsightsView: boolean;
	};
}

const defaultState: IStreakStore = {
	predictions: [],
	resentHistory: [],
	requestStatePicks: RequestState.IDLE,
	requestStateHistory: RequestState.IDLE,
	requestStateFriends: RequestState.IDLE,
	history: {
		predictions: [],
		nextPage: false,
	},
	friendHistory: {
		history: [],
		nextPage: false,
	},
	friendPicksByPlayerId: {},
	modals: {
		mulliganModalState: false,
		isOpenInsightsView: false,
	},
};

const onRequested = (state: IStreakStore) => {
	return {
		...state,
		requestStatePicks: RequestState.Requested,
	};
};

export const streak = createReducer({}, defaultState)
	.on(addPlayer, onRequested)
	.on(removePick, onRequested)
	.on(fetchPredictions, onRequested)
	.on(toggleMulliganModal, (state) => ({
		...state,
		modals: {
			...state.modals,
			mulliganModalState: !state.modals.mulliganModalState,
		},
	}))
	.on(hideMulliganModal, (state) => ({
		...state,
		modals: {
			...state.modals,
			mulliganModalState: false,
		},
	}))
	.on(fetchFriendPicks, (state) => ({
		...state,
		requestStateFriends: RequestState.Requested,
	}))
	.on(getPredictionsPutStoreSuccess, (state, payload) => ({
		...state,
		predictions: payload.predictions,
		resentHistory: payload.resentHistory,
		requestStatePicks: RequestState.Received,
	}))
	.on(getHistoryAPISuccess, (state, payload) => ({
		...state,
		history: payload,
		requestStateHistory: RequestState.Received,
	}))
	.on(fetchFriendPicksSuccess, (state, payload) => ({
		...state,
		friendHistory: payload,
		requestStateFriends: RequestState.Received,
	}))
	.on(fetchFriendPicksByPlayerPutSuccess, (state, payload) => ({
		...state,
		friendPicksByPlayerId: {
			...state.friendPicksByPlayerId,
			[payload.playerId]: payload,
		},
		requestStateFriends: RequestState.Received,
	}))
	.on(clearPicksHistory, (state) => ({
		...state,
		friendHistory: {
			...defaultState.friendHistory,
		},
	}))
	.on(setInsightsViewState, (state, payload) => ({
		...state,
		modals: {
			...state.modals,
			isOpenInsightsView: payload,
		},
	}));
